module.exports = __webpack_public_path__ + "static/media/camden-county-environmental-center.326d14ae.md";